import React from "react";
import { PlanGrid, PlanSkeletonCard } from "../styles";

const PLAN_CARD_COUNT = 4;

export const PlanSkeletonGrid: React.FC = () => (
  <PlanGrid
    data-testid="plan-skeleton"
    role="status"
    aria-label="Loading targets"
    aria-busy="true"
  >
    {Array.from({ length: PLAN_CARD_COUNT }).map((_, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <PlanSkeletonCard key={i} aria-hidden="true" />
    ))}
  </PlanGrid>
);
